import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import chevronRight from '../../assets/icons/chevron-right.png';

const PaginationNextSmall = ({clang, setNextPage}) => {
    return (
        <button type="button" className="pagination__next--small" onClick={() => setNextPage()} title={lang[clang].pagination.next_title}>
            <img className="pagination__next--small__img" src={chevronRight} alt="" />
        </button>
    );
};

PaginationNextSmall.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationNextSmall);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationNextSmall.js